// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const infirmary = defineModel({
  id: "infirmary",
  batchId: "future",
  name: "Infirmary",
  tags: ["building","infirmary","low-poly","age-of-mcp","future"],
  summary: "An infirmary that treats injury and illness with medicine and cloth.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.5, 1.05), color: "#eceae3", position: [0, 0.39, 0] },
      { geometry: new THREE.BoxGeometry(1.55, 0.09, 1.1), color: "#c8c3b4", position: [0, 0.185, 0] },
      { geometry: new THREE.BoxGeometry(0.09, 0.5, 0.09), color: "#c8c3b4", position: [-0.75, 0.39, -0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.5, 0.09), color: "#c8c3b4", position: [0.75, 0.39, -0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.5, 0.09), color: "#c8c3b4", position: [-0.75, 0.39, 0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.5, 0.09), color: "#c8c3b4", position: [0.75, 0.39, 0.525] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.775, 0.5, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.775, 0.5, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.775, 0.5, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.775, 0.5, 0.775] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.98, 1.05), color: "#eceae3", position: [0, 0.63, 0] },
      { geometry: new THREE.BoxGeometry(1.55, 0.09, 1.1), color: "#c8c3b4", position: [0, 0.185, 0] },
      { geometry: new THREE.BoxGeometry(0.09, 0.98, 0.09), color: "#c8c3b4", position: [-0.75, 0.63, -0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.98, 0.09), color: "#c8c3b4", position: [0.75, 0.63, -0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.98, 0.09), color: "#c8c3b4", position: [-0.75, 0.63, 0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.98, 0.09), color: "#c8c3b4", position: [0.75, 0.63, 0.525] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.775, 0.75, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.775, 0.75, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.775, 0.75, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.775, 0.75, 0.775] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.98, 1.05), color: "#eceae3", position: [0, 0.63, 0] },
      { geometry: new THREE.BoxGeometry(1.55, 0.09, 1.1), color: "#c8c3b4", position: [0, 0.185, 0] },
      { geometry: new THREE.BoxGeometry(0.09, 0.98, 0.09), color: "#c8c3b4", position: [-0.75, 0.63, -0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.98, 0.09), color: "#c8c3b4", position: [0.75, 0.63, -0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.98, 0.09), color: "#c8c3b4", position: [-0.75, 0.63, 0.525] },
      { geometry: new THREE.BoxGeometry(0.09, 0.98, 0.09), color: "#c8c3b4", position: [0.75, 0.63, 0.525] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.804194), color: "#8a5a44", position: [0, 1.35, 0.2925], rotation: [0.666347, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.804194), color: "#8a5a44", position: [0, 1.35, -0.2925], rotation: [-0.666347, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.74, 0.085, 0.085), color: "#c8c3b4", position: [0, 1.58, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.22, 0.04), color: "#cc3a34", position: [0, 1.32, 0.485] },
      { geometry: new THREE.BoxGeometry(0.22, 0.06, 0.04), color: "#cc3a34", position: [0, 1.32, 0.485] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.5, 6), color: "#c8c3b4", position: [-0.22, 0.39, 0.705] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.5, 6), color: "#c8c3b4", position: [0.22, 0.39, 0.705] },
      { geometry: new THREE.BoxGeometry(0.66, 0.06, 0.3), color: "#8a5a44", position: [0, 0.67, 0.645] },
      { geometry: new THREE.BoxGeometry(0.34, 0.5, 0.05), color: "#5a4632", position: [0, 0.39, 0.535] },
      { geometry: new THREE.BoxGeometry(0.16, 0.4, 0.16), color: "#9a8f7c", position: [-0.45, 1.46, -0.2] },
      { geometry: new THREE.BoxGeometry(0.2, 0.06, 0.2), color: "#c8c3b4", position: [-0.45, 1.66, -0.2] },
    ] },
  ],
  animations: [],
});
